import { render } from "./CreateOrEdit.vue?vue&type=template&id=64f78115&scoped=true"
import script from "./CreateOrEdit.vue?vue&type=script&lang=js"
export * from "./CreateOrEdit.vue?vue&type=script&lang=js"

import "./CreateOrEdit.vue?vue&type=style&index=0&id=64f78115&lang=scss&scoped=true"

import exportComponent from "/builds/intratone/interface/intratoneinfov4/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-64f78115"]])

export default __exports__